import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import dompurify from "dompurify"
import IncidentTimelineTypes from "../../../../../Types/IncidentTimelineTypes"
import "./IncidentTimelineViewer.css"

interface Props {
    openItem: IncidentTimelineTypes
    toggleIncidentTimelineViewer: Function
}

class IncidentTimelineViewer extends Component<Props, {}> {

    render() {

        const openItem = this.props.openItem

        return (
            <div className="IncidentTimelineViewer">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Header>
                        <div className="IncidentTimelineViewerModalHeader">
                            <p><span id="incident-timeline-viewer-modal-header-left">Viewing:</span> {openItem.TimelineTitle}</p>
                            {openItem.IncidentTimelineTypeDesc === "correspondence" && <span className="material-icons">email</span>}
                            {openItem.IncidentTimelineTypeDesc === "note" && <span className="material-icons">chat</span>}
                            {openItem.IncidentTimelineTypeDesc === "event" && <span className="material-icons">event</span>}
                            {openItem.IncidentTimelineTypeDesc === "form" && <span className="material-icons">dynamic_feed</span>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {openItem.IncidentTimelineTypeDesc !== "form" && <div className="IncidentTimelineViewerModalBody" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(openItem.NoteText) }}></div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="IncidentTimelineViewerModalFooter">
                            <Button variant="secondary" onClick={() => this.props.toggleIncidentTimelineViewer()}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default IncidentTimelineViewer